import { render, staticRenderFns } from "./Saturation.vue?vue&type=template&id=440b1592&"
import script from "./Saturation.vue?vue&type=script&lang=ts&"
export * from "./Saturation.vue?vue&type=script&lang=ts&"
import style0 from "./Saturation.vue?vue&type=style&index=0&id=440b1592&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports